"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormModelState = void 0;
const ike_map_1 = require("../ike.map");
const form_metadata_1 = require("./form.metadata");
class FormModelState {
    constructor(form) {
        this.frozen = false;
        /**
         * This object contains two kinds of state:
         * 1. An entry for each field, where the key is `${this.id}:${fieldID}` and the value is FormModelFieldState.
         * 2. An entry for the root subform, where the key is `:${this.id}` and the value is FormFieldSubFormState.
         *
         * Note that subform field states contains a list of fieldIds referencing the keys of the field states they own.
         */
        this.fields = new ike_map_1.IkeMap();
        this._name = '';
        this._displayName = '';
        this._displayVersion = 0;
        this._description = '';
        this._updatedAt = new Date();
        this._createdAt = new Date();
        this._updatedBy = '';
        this._v = 1;
        this._metadata = new form_metadata_1.FormModelMetadata(form);
    }
    get id() {
        return this._id;
    }
    set id(value) {
        this._id = value;
    }
    get revision() {
        return this._revision;
    }
    set revision(value) {
        this._revision = value;
    }
    /**
     * @deprecated Mapsight-web form designer might still use this.
     */
    get version() {
        return this._version;
    }
    set version(value) {
        this._version = value;
    }
    /**
     * The first revision in the revision history of this form.
     */
    get rootFormId() {
        return this._rootFormId;
    }
    set rootFormId(value) {
        this._rootFormId = value;
    }
    get name() {
        return this._name;
    }
    set name(value) {
        this._name = value;
    }
    get displayName() {
        return this._displayName;
    }
    set displayName(value) {
        this._displayName = value;
    }
    get displayVersion() {
        return this._displayVersion;
    }
    set displayVersion(value) {
        this._displayVersion = value;
    }
    get description() {
        return this._description;
    }
    set description(value) {
        this._description = value;
    }
    get updatedAt() {
        return this._updatedAt;
    }
    set updatedAt(value) {
        this._updatedAt = value;
    }
    get createdAt() {
        return this._createdAt;
    }
    set createdAt(value) {
        this._createdAt = value;
    }
    get updatedBy() {
        return this._updatedBy;
    }
    set updatedBy(value) {
        this._updatedBy = value;
    }
    get v() {
        return this._v;
    }
    set v(value) {
        this._v = value;
    }
    get metadata() {
        return this._metadata;
    }
    set metadata(value) {
        this._metadata = value;
    }
    setDisplayName(displayName) {
        this.displayName = displayName;
    }
    setDisplayVersion(displayVersion) {
        this.displayVersion = displayVersion;
    }
    setDescription(description) {
        this.description = description;
    }
    getFieldValue(fieldId) {
        return this.fields.get(fieldId);
    }
    setFieldValue(fieldId, state) {
        if (this.frozen) {
            throw new Error(`Field ${fieldId}: Writing frozen state.`);
        }
        this.fields.set(fieldId, state);
    }
    removeField(fieldId) {
        this.fields.delete(fieldId);
    }
}
exports.FormModelState = FormModelState;
//# sourceMappingURL=form.state.js.map